<template>
    <div class="p-animal-group">
        <breadcrumb :items="breadcrumbs"></breadcrumb>

        <v-container fluid>
            <GroupHeader :primaryFarm="primaryFarm" v-if="primaryFarm" />
            <GroupInfo @group:updated="onGroupUpdated" :group="group" v-if="group" />
            <GroupHistory :group="group" v-if="group" />
        </v-container>
    </div>
</template>

<script>
import FarmService from "@/_services/farmService";
import gql from 'graphql-tag';

import GroupHeader from "./groups/GroupHeader.vue";
import GroupHistory from "./groups/GroupHistory.vue";
import GroupInfo from "./groups/GroupInfo.vue";

export default {
    apollo: {
        group: {
            query: gql`query group($id: Int!) {
                group(id: $id) {
                    animals {
                        id
                    }
                    id
                    animalCounts
                    bodyWeight
                    name
                    status
                    geofenceZoneId {
                        id
                        geofenceName
                    }
                }
            }`,
            variables() {
                return {
                    id: parseInt(this.$route.params.id),
                }
            },
            fetchPolicy: 'network-only',
        }
    },

    components: {
        GroupHeader,
        GroupHistory,
        GroupInfo,
    },

    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t("dashboard"),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t("animals"),
                    disabled: false,
                    to: "/animals",
                },
                {
                    text: this.$t("animalGroup"),
                    disabled: true,
                },
            ],
            primaryFarm: null,
        }
    },

    methods: {
        onGroupUpdated() {
            this.$apollo.queries.group.refetch();
        },
    },

    async mounted() {
        const { data } = await FarmService.getPrimaryFarm();
        this.primaryFarm = data;
    },

    name: "AnimalGroup",
}
</script>
